import * as d3 from 'd3'

export default {
  methods: {

    chart_Controller(chtData, area_) {
      chtData.forEach(d => {
        d.month = this.timeline.month.find(f => d.mDate >= f.sDate && d.mDate <= f.eDate).mDate
      })

      let sChart = this.canvasChart
      .append('g')
      .attr('class', 'CHARTS')
      .attr('transform', `translate(0, 0)`)
      .style('font-family', 'roboto')

      this.draw_Grid(sChart, area_) // -----> draw_Elements.js
      
      // Call Chart
      this.ChartStyle.filter(f=> f.cType == 'BAR').forEach((d,i)=> {
        this.draw_BarChart(sChart, chtData, d, area_)
      })

      this.ChartStyle.filter(f=> f.cType == 'LINE').forEach((d,i)=> {
        if (d.lType == 'ACT') chtData = chtData.filter(f=> f.CDATE.substring(0, 7) <= this.timeline.cutoff.substring(0, 7))
        this.draw_LineChart(sChart, chtData, d)
      })

    },


    draw_Grid(selection, area_) {
      let grid = area_.height / 5

      for(let i=0; i<6; i++) {
        selection // Grid
        .append('line')
        .attr('x1', 0).attr('x2', area_.width)
        .attr('y1', grid * i).attr('y2', grid * i)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)
        .attr('opacity', .5)

        selection // Primary Axis
        .append('text')
        .attr('x', -2)
        .attr('y', area_.height - (grid * i) + 9*0.26)  
        .style('font-size', 9).style('fill', '#757575')
        .attr('text-anchor', 'end')
        .text((this.primary.max * (i*.2)).toFixed(0)+ '%')

        selection // Secoundary Axis
        .append('text')
        .attr('x', area_.width + 2)
        .attr('y', area_.height - (grid * i) + 9*0.26)
        .style('font-size', 9).style('fill', '#757575')
        .attr('text-anchor', 'start')
        .text((100 * (i*.2)).toFixed(0))
      }
    },


    draw_BarChart(selection, chtData, st_, area_) {

      let barWidth = 4

      let barChart = selection
      .append('g')
      .attr('transform', `translate(0.5,0)`)

      chtData.forEach((d,i)=> {
        let value = d[st_.code]
        if(value < 0) value = 0

        barChart
        .append('rect')
        .attr('x', (st_.lType == 'PLAN') ? this.timeline.scale(d.month) - barWidth : this.timeline.scale(d.month))
        .attr('y', area_.height-this.primary.axis(value))
        .attr('width', barWidth).attr('height', this.primary.axis(value))
        .attr('fill', st_.sColor).attr('opacity', st_.opacity)
      })
    },


    draw_LineChart(selection, chtData, st_) {
      let dev = null
      let lastOne = chtData.find(f => f.CDATE.substring(0, 7) == this.timeline.cutoff.substring(0, 7))
      if(lastOne) {
        dev = lastOne[this.ChartStyle[1].code]-lastOne[this.ChartStyle[0].code]
      }

      let lineFunc = d3.line()
      .x(d => this.timeline.scale(new Date(d.month)))
      .y(d => this.secoundary.axis(d[st_.code]))

      let lineChart = selection
      .append('g')
      .attr('transform', `translate(0,0)`)
      .attr('font-family', 'roboto')

      lineChart
      .append('path')
      .attr('d', lineFunc(chtData))
      .style('stroke', (st_.lType == 'ACT' && dev < 0) ? '#F35E90': st_.sColor)
      .style('stroke-dasharray', (st_.lType == 'PLAN') ? (3,3) : (0,0))
      .style('stroke-width', st_.sWidth).style('fill', 'none')

      // draw the final cumulative value
      if(st_.lType == 'ACT') {
        if(!lastOne) return
        lineChart
        .append('text')
        .attr('x', this.timeline.scale(new Date(lastOne.month)))
        .attr('y', this.secoundary.axis(lastOne[st_.code]) + 10*0.26)
        .style('font-size', 10)
        .style('fill', (dev < 0) ? '#F35E90' : '#44A9DF')
        .text(lastOne[st_.code]+'%')
      }
    },


  }
}